import { mq } from '@phishtool/ui';
import styled from 'styled-components';
import { Paragraph } from '~components/paragraph';
export const StyledFAQWrapper = styled.div.withConfig({ displayName: "StyledFAQWrapper", componentId: "sc-1kq2qej" }) `
  ${(props) => mq({
    paddingBottom: [0, null, props.theme.spacers.x3],
})}
`;
export const StyledFAQQuestionWrapper = styled.div.withConfig({ displayName: "StyledFAQQuestionWrapper", componentId: "sc-1kw0kmy" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.x4};
  width: 100%;
  align-items: center;

  &:hover p {
    color: ${(props) => props.theme.colors.celticBlue};
  }
`;
export const StyledFAQQuestion = styled(Paragraph).withConfig({ displayName: "StyledFAQQuestion", componentId: "sc-12ev8cv" }) `
  flex: 1;
  margin: 0;
  padding: ${(props) => props.theme.spacers.x3} 0;
`;
export const StyledFAQAnswer = styled(Paragraph).withConfig({ displayName: "StyledFAQAnswer", componentId: "sc-17ko694" }) `
  margin: 0 0 ${(props) => props.theme.spacers.x3};
  padding: 0 0 0 ${(props) => props.theme.spacers.x4};
  border-left: 5px solid ${(props) => props.theme.colors.silverPearl};
`;
